import type { NamedEffect, TimeAnimationOptions, AnimationDef } from '@wix/thunderbolt-becky-types'

export type ConvertEffectToAnimationDef = (animation: TimeAnimationOptions) => Partial<AnimationDef>

export const convertEffectToAnimationDef: ConvertEffectToAnimationDef = (animation) => {
	const effect = animation.namedEffect || animation.keyframeEffect || ({} as NamedEffect)
	const propertiesToOmit = ['id', 'type']

	return {
		name: effect.type,
		duration: animation.duration ? animation.duration / 1000 : 0,
		delay: animation.delay ? animation.delay / 1000 : 0,
		params: Object.fromEntries(Object.entries(effect).filter(([key]) => !propertiesToOmit.includes(key))),
		iterations: animation.iterations,
		fill: animation.fill,
		alternate: animation.alternate,
		easing: animation.easing,
	}
}
